export const plantsArray: Array<string> = [
  "abies",
  "absent",
  "abu",
  "acacia",
  "acer",
  "achar",
  "aconitum",
  "aehobak",
  "aesculus",
  "aftergrass",
  "aftermath",
  "agosto",
  "aguacate",
  "ailanthus",
  "ajo",
  "akolutophyte",
  "albisoara",
  "albizia",
  "alexander",
  "alicante",
  "alnus",
  "altonobles",
  "alunica",
  "amaimo",
  "amaliaboom",
  "amandi",
  "amaranthaceae",
  "amphiphytes",
  "andenhorn",
  "anemone",
  "angiospermae",
  "angiosperms",
  "anisa",
  "anisohydric",
  "ansonica",
  "antonovka",
  "applecrab",
  "arbutus",
  "arevik",
  "argessis",
  "arkadia",
  "armavir",
  "asati",
  "asazuke",
  "aspen",
  "asteraceae",
  "astilbe",
  "astrachan",
  "atchara",
  "augusta",
  "avakaya",
  "azoychka",
  "azur",
  "baekkimchi",
  "balcic",
  "baldaszek",
  "baldo",
  "bambal",
  "bambusoideae",
  "bane",
  "banyan",
  "barilla",
  "barry",
  "basicata",
  "basil",
  "bean",
  "beatrixboom",
  "beauregard",
  "beet",
  "begonia",
  "bekzodi",
  "berbecel",
  "bergamotte",
  "betel",
  "bettarazuke",
  "betula",
  "bianca",
  "biancolella",
  "bilbaina",
  "bimi",
  "bindweed",
  "bine",
  "bitterwood",
  "bojna",
  "bomdong",
  "borage",
  "borosica",
  "borsdorf",
  "boscanata",
  "bostongurka",
  "bosvoldi",
  "botok",
  "bourbon",
  "bovale",
  "boyken",
  "brandywine",
  "brassicaceae",
  "broccoflower",
  "broccoli",
  "broussonetia",
  "burdinche",
  "cabbage",
  "cacao",
  "calabaza",
  "calcicole",
  "calcifuge",
  "calocedrus",
  "calville",
  "campanula",
  "candyleaf",
  "cantaloupe",
  "capsicum",
  "cardinal",
  "cardoon",
  "carosello",
  "carpinus",
  "carrot",
  "carya",
  "castanea",
  "casuarina",
  "catalpa",
  "catarratto",
  "catillac",
  "cauliflower",
  "caulilini",
  "cedrela",
  "cedrus",
  "celastrus",
  "celeriac",
  "celery",
  "celosia",
  "celtis",
  "cercidiphyllum",
  "cercis",
  "cetatuia",
  "chacasina",
  "chamaecyparis",
  "chamaephyte",
  "chamomile",
  "chard",
  "chardonnay",
  "chasmophyte",
  "chervil",
  "chickpea",
  "chimera",
  "chionanthus",
  "chiparati",
  "chives",
  "cicely",
  "cilantro",
  "cimighiera",
  "citrus",
  "cladrastis",
  "clematis",
  "climbing",
  "clove",
  "cockscomb",
  "codreanca",
  "collaos",
  "coluria",
  "comadre",
  "comfrey",
  "conifer",
  "corbeasca",
  "cornichons",
  "cornus",
  "coro",
  "corylus",
  "costoya",
  "cotinus",
  "cottonwood",
  "courbu",
  "craita",
  "crataegus",
  "cregueira",
  "crimposie",
  "crop",
  "crosby",
  "cruciulita",
  "cryptomeria",
  "cryptophyte",
  "cucumber",
  "cultigen",
  "cultivar",
  "cupressus",
  "cypress",
  "dahbedi",
  "dahlia",
  "daisy",
  "dal",
  "dandelion",
  "davidia",
  "davlatboy",
  "dedovnik",
  "desfontainia",
  "dianthus",
  "dill",
  "dinka",
  "diospyros",
  "dodrelyabi",
  "dongchimi",
  "drosera",
  "duras",
  "dwarfing",
  "dziczka",
  "echalion",
  "echeveria",
  "edamame",
  "edelborsdorfer",
  "edimental",
  "efemeroidy",
  "eggplant",
  "elaeagnus",
  "elbling",
  "elymus",
  "embryophytes",
  "emergent",
  "emmaboom",
  "endigia",
  "endive",
  "epuroaica",
  "ericoid",
  "eriobotrya",
  "errezil",
  "espalier",
  "espleje",
  "eucalyptus",
  "eudicots",
  "euodia",
  "eztika",
  "faba",
  "fagaceae",
  "fagus",
  "faidherbia",
  "fea",
  "fern",
  "ferroi",
  "fetita",
  "fiano",
  "ficus",
  "filippa",
  "firtigaia",
  "flagellariaceae",
  "flogdrake",
  "focsaneanca",
  "folla",
  "fontanesia",
  "forage",
  "forb",
  "fragaria",
  "francuse",
  "fraxinus",
  "freixerana",
  "friggitello",
  "fry",
  "fuella",
  "fuentes",
  "fukujinzuke",
  "gajard",
  "galangal",
  "galgalos",
  "galia",
  "gari",
  "garlic",
  "gayane",
  "gaztelu",
  "gentiana",
  "geophyte",
  "geotjeori",
  "gezamin",
  "gilliflower",
  "gime",
  "ginger",
  "ginkgo",
  "gladstone",
  "gleditsia",
  "glubus",
  "glycophytes",
  "goicoetxe",
  "goro",
  "gossypium",
  "gourd",
  "govakan",
  "grabitoare",
  "graft",
  "grains",
  "graminoid",
  "grapevine",
  "grass",
  "grelos",
  "gropello",
  "groundcover",
  "guigne",
  "guje",
  "gulkand",
  "gulnoz",
  "gunda",
  "gurvak",
  "guyot",
  "gymnocladus",
  "haitang",
  "halophyte",
  "hanazuke",
  "hanger",
  "hapaxanth",
  "harumanis",
  "hay",
  "haylage",
  "heliophyte",
  "hellebore",
  "helophyte",
  "hemicryptophyte",
  "heptacodium",
  "herb",
  "heshiko",
  "hibakujumoku",
  "hidabeni",
  "hierro",
  "hillbilly",
  "hinokaburazuke",
  "hiroshimana",
  "hojanca",
  "honeydew",
  "hornbeam",
  "horsechestnut",
  "houseplant",
  "hoym",
  "hydrophyte",
  "hydrotherophyte",
  "hygrophytes",
  "idiochorophyt",
  "ilex",
  "indigen",
  "intercropping",
  "interstock",
  "iordan",
  "iparaguirre",
  "iridaceae",
  "ironbark",
  "isoetid",
  "ivette",
  "jamibo",
  "jangajji",
  "jauregizarra",
  "jinchak",
  "jjanji",
  "jubilee",
  "judaine",
  "judeline",
  "juglans",
  "julianaboom",
  "juniperus",
  "kale",
  "kamoliy",
  "kamut",
  "kanzler",
  "karamidaikon",
  "karashizuke",
  "karpatiosorbus",
  "kasuzuke",
  "kimchi",
  "kinderboom",
  "knieperkohl",
  "koelreuteria",
  "kohlrabi",
  "kokedama",
  "kombu",
  "koningslinde",
  "kreaca",
  "kroezeboom",
  "kumato",
  "kumquat",
  "laburnum",
  "lagerstroemia",
  "lambrusco",
  "landetxo",
  "landrace",
  "larch",
  "larix",
  "laurus",
  "leek",
  "legume",
  "lem",
  "lemnides",
  "lenape",
  "lentil",
  "leptophyllous",
  "lettuce",
  "leuros",
  "liana",
  "lilium",
  "limo",
  "liquidambar",
  "liquorice",
  "liriodendron",
  "lithophyte",
  "luneda",
  "lutherbuchen",
  "luthereiche",
  "maclura",
  "macrophanerophytes",
  "macrophyte",
  "magnolia",
  "maize",
  "maltaise",
  "malus",
  "malva",
  "malvasia",
  "mamula",
  "mandaka",
  "mandarina",
  "mangelwurzel",
  "mangrove",
  "manigua",
  "manttoni",
  "mantuaner",
  "marjoram",
  "marrow",
  "mashua",
  "matsumaezuke",
  "maurandya",
  "meana",
  "mehsere",
  "mellunaro",
  "melon",
  "mesophyte",
  "metallophyte",
  "metaphyt",
  "microgreen",
  "mignonettes",
  "misozuke",
  "mitraria",
  "mokatia",
  "moldova",
  "monarch",
  "monben",
  "morenas",
  "moringa",
  "morus",
  "mozuku",
  "mugwort",
  "mukeunji",
  "mukowewumbeko",
  "muscat",
  "muskmelon",
  "myriophyllum",
  "myrmecophyte",
  "naniwayasai",
  "napa",
  "narazuke",
  "narcissus",
  "narekatsi",
  "natazuke",
  "neagra",
  "nederwiet",
  "neophyte",
  "nesple",
  "nishinzuke",
  "nitrophobe",
  "nitrophyte",
  "niwaki",
  "noccaea",
  "noonsom",
  "nopal",
  "nukazuke",
  "nyonbeka",
  "nyssa",
  "oak",
  "oenothera",
  "officinal",
  "okra",
  "olea",
  "ombrophobe",
  "ondomotxa",
  "onion",
  "orchidaceae",
  "ortell",
  "ostrya",
  "panquerina",
  "papaver",
  "papaveraceae",
  "parellada",
  "parrotia",
  "parsley",
  "parsnip",
  "pasaresc",
  "patzolua",
  "paulownia",
  "paxeta",
  "pea",
  "peanut",
  "peapod",
  "pearmain",
  "peiro",
  "peraza",
  "perico",
  "peros",
  "phanerogams",
  "phanerophyte",
  "phellodendron",
  "phorophyte",
  "photinia",
  "picea",
  "pickle",
  "picota",
  "pimienta",
  "pinaceae",
  "pincar",
  "pinus",
  "piolla",
  "pistacia",
  "piza",
  "plant",
  "platanus",
  "plop",
  "poaceae",
  "pochas",
  "pollenizer",
  "polycarpic",
  "pomato",
  "pomelo",
  "poncirus",
  "pontellas",
  "poplar",
  "poppy",
  "populus",
  "potato",
  "potpourri",
  "primrose",
  "primula",
  "prunus",
  "pseudocereal",
  "pseudotsuga",
  "psychophile",
  "ptelea",
  "pterocarya",
  "pumpkin",
  "punica",
  "puntarelle",
  "purebred",
  "pwotal",
  "pyrophyte",
  "pyrus",
  "quelite",
  "rabal",
  "rabala",
  "radicchio",
  "radish",
  "rambour",
  "ramona",
  "rangpur",
  "rapeweed",
  "reed",
  "regona",
  "reinette",
  "remo",
  "rhubarb",
  "ribolla",
  "ripogonum",
  "riscadas",
  "riunite",
  "rkatsiteli",
  "robinia",
  "rohdos",
  "rojas",
  "romana",
  "rootstock",
  "rosa",
  "rose",
  "rosemary",
  "roveja",
  "rozsada",
  "rucola",
  "rue",
  "sabzi",
  "saccharum",
  "saengchae",
  "sage",
  "salix",
  "salzgurke",
  "samosiewy",
  "sankaizuke",
  "sansai",
  "santiaguesa",
  "sapiazhanka",
  "sappanwood",
  "sarba",
  "savory",
  "saxifragales",
  "scallion",
  "schinus",
  "sciophyte",
  "sclerophyll",
  "scuturatoare",
  "seedling",
  "senmaizuke",
  "sequoia",
  "sevillana",
  "shallot",
  "shepody",
  "shibazuke",
  "shinboku",
  "shiokombu",
  "shitakusa",
  "shrub",
  "shurb",
  "silphium",
  "sinapis",
  "sinomenium",
  "siraegi",
  "sisal",
  "slavyanka",
  "snag",
  "solafuente",
  "solyas",
  "sophora",
  "sorbus",
  "southernwood",
  "soybean",
  "spar",
  "sparacello",
  "spinach",
  "sprouting",
  "strawberry",
  "subshrub",
  "sugarcane",
  "suguki",
  "sukombu",
  "sunkizuke",
  "sunviva",
  "superrosids",
  "suptall",
  "sycamore",
  "syringa",
  "tabardilla",
  "takuan",
  "talisman",
  "tamaioara",
  "tangerine",
  "tangsuan",
  "tarde",
  "taro",
  "tarragon",
  "taxus",
  "tayo",
  "teinturier",
  "tempera",
  "terret",
  "tetradium",
  "therophyte",
  "thyme",
  "tigerella",
  "tigvoasa",
  "tilia",
  "tochiotome",
  "toekomstboom",
  "tomaccio",
  "tomato",
  "toona",
  "torshi",
  "tortillera",
  "tracheophyte",
  "transparente",
  "transplant",
  "traveller",
  "tree",
  "trifolium",
  "trinitario",
  "trophophyte",
  "tsugaru",
  "tsukemono",
  "tulip",
  "tulipa",
  "tumbleweed",
  "turnip",
  "txalaka",
  "ugarte",
  "ulmus",
  "umeboshi",
  "vanda",
  "vanilla",
  "vegetable",
  "verdedoncella",
  "verdellas",
  "verdialona",
  "verdinal",
  "viburnum",
  "victoria",
  "vine",
  "vivagrande",
  "volunteer",
  "wasabizuke",
  "watercress",
  "watermelon",
  "wattleseed",
  "weed",
  "wheatgrass",
  "whitesmith",
  "wildflower",
  "wilhelminaboom",
  "windrow",
  "wybert",
  "xaneira",
  "xerophyte",
  "xerotherm",
  "yakuboku",
  "yakusugi",
  "yam",
  "yew",
  "yumbeka",
  "zapis",
  "zarchopon",
  "zauberpflanze",
  "zelkova",
  "zinfandel",
  "zorany",
  "zucchini",
];
